import React, { useEffect, useState } from 'react';

import ReactApexChart from 'react-apexcharts';

import LoadingSpinner from 'CommonComponents/LoadingSpinner';

export default function ProjectDashboardActivityTimeline(props) {
    const [series, setSeries] = useState([]);

    useEffect(() => {
        const milestones = { name: $t('Milestones'), data: [] };
        const activities = { name: $t('Activities'), data: [] };

        Object.values(props.data).forEach((yearData) => {
            milestones.data.push(yearData.milestones);
            activities.data.push(yearData.activities);
        });

        setSeries([milestones, activities]);
    }, [props.data]);

    // ApexCharts' bar renderer (createBorderRadiusArr) reads `series[0].length` without guarding the
    // empty case, so mounting/updating the chart with an empty series throws an unhandled
    // "Cannot read properties of undefined (reading 'length')". The series is empty on the first render
    // (before the effect runs) and whenever the event has no milestone activities (props.data === {}),
    // so only render the chart once there is at least one data point.
    const hasData = series.some((dataset) => dataset.data.length > 0);

    const options = {
        chart: {
            type: 'bar',
            height: 350,
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '30%',
                endingShape: 'rounded',
            },
        },
        dataLabels: {
            enabled: false,
        },
        xaxis: {
            categories: Object.keys(props.data),
            title: {
                text: 'Years',
            },
        },
        yaxis: {
            title: {
                text: '',
            },
        },
        legend: {
            position: 'top',
        },
    };

    return (
        <div className="table__card">
            <div className="tw-mb-6">
                <h4 className="table__header">{$t('Activity Timeline - by Target Completion Date')}</h4>
            </div>
            <div>
                {props.loading ? (
                    <div className="tw-p-6">
                        <LoadingSpinner />
                    </div>
                ) : hasData ? (
                    <ReactApexChart options={options} series={series} type="bar" height={350} />
                ) : (
                    <div className="tw-p-6 tw-text-center tw-text-charcoal-50">{$t('No data provided')}</div>
                )}
            </div>
        </div>
    );
}
